import { Button, Modal } from "react-bootstrap"
import $ from 'jquery';
import { useDispatch } from "react-redux";
import { togglePlanSection_D } from "../../../../actions/showDisplayModalAction";


const UpgradeStudio = ({ open, onHide }) => {

    const dispatch = useDispatch();

    const onUpgradeClick = (e) => {
        setTimeout(() => {
            dispatch(togglePlanSection_D(true));
            onHide()
        }, 100);

        $('#morePopupId').hide()
    }

    return (
        <Modal size="lg" dialogClassName=" modal-dialog-centered modal-dialog" show={open} onHide={onHide} >
            <Modal.Header closeButton className="border-0 pb-0"></Modal.Header>
            <Modal.Body>
                <div className="row py-5">
                    <div className="col-lg-12"> 
                        <div className="upgredeMain text-center">
                            <iframe id="studioVideo" src="https://player.vimeo.com/video/589330860?autoplay=1&muted=0&controls=0" width="100%" height="400" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen title="Welcome To Taggbox Display Studio"></iframe>
                            <div className="permissionMsg my-4 px-4">
                                <h4 className="ErrorMsg">Studio</h4>
                                <p className="msgSec">Enhance the social wall's presentation by adding gamification apps. Choose scene layout, add media, youtube vidoes, calender, weather forecast, countdown, and more with studio.</p>
                            </div>
                            <div className="buttonUpgred mb-3">
                                <Button variant="primary" type="button"  id="addonFeaturesScroll"onClick={(e)=>onUpgradeClick()} className="px-5" data-factors-click-bind="true"> Upgrade Now </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default UpgradeStudio

